import { WidgetLink } from '../types/container-data';

export const normalizeParams = ({
  params = [],
}: Partial<Pick<WidgetLink, 'params'>>) =>
  params.reduce(
    (paramObj, { key, value }) => ({ ...paramObj, [key]: value }),
    {},
  );
